import { apiDelete, apiGet, apiPatch, apiPost } from './client';
import type {
  CompleteLessonResult,
  DeleteAccountResult,
  ExerciseAttemptList,
  GamificationView,
  MeView,
  ProgressView,
  SubmitExerciseAnswersResult,
} from './progress.types';

export const progressApi = {
  getMe: () => apiGet<MeView>('/me'),
  getGamification: () => apiGet<GamificationView>('/me/gamification'),
  getProgress: () => apiGet<ProgressView>('/me/progress'),
  completeLesson: (lessonId: string) => apiPost<CompleteLessonResult>(`/me/lessons/${lessonId}/complete`),
  submitExerciseAnswers: (exerciseSetId: string, answers: { order: number; picked: number }[], durationSeconds?: number) =>
    apiPost<SubmitExerciseAnswersResult>(`/me/exercise-sets/${exerciseSetId}/answers`, { answers, durationSeconds }),
  /** Lịch sử nộp bài của 1 bộ đề, mới nhất trước. `cursor` = nextCursor của trang trước. */
  listExerciseAttempts: (exerciseSetId: string, cursor?: string | null) =>
    apiGet<ExerciseAttemptList>(
      `/me/exercise-attempts?exerciseSetId=${encodeURIComponent(exerciseSetId)}${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`,
    ),
  updateDailyGoal: (goals: { vocab: number; grammar: number }) =>
    apiPatch<{ vocab: number; grammar: number }>('/me/daily-goal', goals),
  updateSrsSettings: (sessionSize: number) =>
    apiPatch<{ sessionSize: number }>('/me/srs-settings', { sessionSize }),
  setSrsEnabled: (srsEnabled: boolean) => apiPatch<{ srsEnabled: boolean }>('/me/srs-settings', { srsEnabled }),
  updateProfile: (displayName: string) => apiPatch<{ displayName: string | null }>('/me/profile', { displayName }),
  /** `password` bỏ trống với tài khoản chỉ đăng nhập Google (không có mật khẩu). */
  deleteAccount: (password?: string) => apiDelete<DeleteAccountResult>('/me', password ? { password } : {}),
};
